import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import userService from "@/services/user";

export const useUsersStore = defineStore("users", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchUsersGrid(companyId) {
    loading.value = true;
    try {
      const res = await userService.getUsersGrid(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchUsersRoles(companyId) {
    loading.value = true;
    try {
      const res = await userService.getUsersRoles(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addUser(payload) {
    loading.value = true;
    try {
      const res = await userService.addUser(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editUser(payload) {
    loading.value = true;
    try {
      const res = await userService.editUser(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteUser(payload) {
    loading.value = true;
    try {
      const res = await userService.deleteUser(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function checkDuplicateField(payload) {
    loading.value = true;
    try {
      const res = await userService.getDuplicateField(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchUsersGrid,
    fetchUsersRoles,
    addUser,
    editUser,
    deleteUser,
    checkDuplicateField,
  };
});
